<app-card-base [title]="title" [hasSubmit]="false" [hasFooter]="true">
  <ng-container header-right *ngTemplateOutlet="headerRight"></ng-container>
  <ng-container main *ngTemplateOutlet="contentMain"></ng-container>
</app-card-base>

<ng-template #contentMain>
  @if(certification){
  <div class="content">
    <div class="details">
      @if (type === PropertyBookletCertificationType.energy) {
      <div *ngIf="certification.propertyTaxId">
        <span class="title">Identifiant logement</span>
        <span class="content">{{ certification.propertyTaxId }}</span>
      </div>
      <div *ngIf="certification.energyDiagnosticId">
        <span class="title">Numéro DPE</span>
        <span class="content">{{ certification.energyDiagnosticId }}</span>
      </div>
      <div *ngIf="certification.energyDiagnosticDate">
        <span class="title">Date du DPE</span>
        <span class="content">{{certification.energyDiagnosticDate | dateFormat}}</span>
      </div>
      <div *ngIf="certification.energyConsumptionClassification">
        <span class="title">Classification énergétique</span>
        <span class="content">{{'enum.EnergyClassification.' + certification.energyConsumptionClassification |
          translate}}</span>
      </div>
      <div *ngIf="certification.greenhouseGasClassification">
        <span class="title">Classification gaz</span>
        <span class="content">{{'enum.EnergyClassification.' + certification.greenhouseGasClassification |
          translate}}</span>
      </div>
      <div class="detail-doc" [class.is-sent]="certification.energyDiagnosticDocument">
        <span>Document DPE</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="certification.energyDiagnosticDocument ? 'Document enregistré' : 'Document absent'">
          {{certification.energyDiagnosticDocument ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      <div *ngIf="certification.energyAuditDate">
        <span class="title">Date de l'audit énergétique</span>
        <span class="content">{{certification.energyAuditDate | dateFormat}}</span>
      </div>
      <div class="detail-doc" [class.is-sent]="certification.energyAuditDocument">
        <span>Document Audit énergétique</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="certification.energyAuditDocument ? 'Document enregistré' : 'Document absent'">
          {{certification.energyAuditDocument ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      }

      @if (type === PropertyBookletCertificationType.quality) {
      <div *ngIf="certification.qualitySealDate">
        <span class="title">Date document qualité</span>
        <span class="content">{{certification.qualitySealDate | dateFormat}}</span>
      </div>
      <div class="detail-doc" [class.is-sent]="certification.qualitySealDocument">
        <span>Document qualité</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="certification.qualitySealDocument ? 'Document enregistré' : 'Document absent'">
          {{certification.qualitySealDocument ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      }

      @if (type === PropertyBookletCertificationType.re2020) {
      <div class="detail-doc" [class.is-sent]="certification.re2020SealDocument">
        <span>Document RE2020</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="certification.re2020SealDocument ? 'Document enregistré' : 'Document absent'">
          {{certification.re2020SealDocument ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      }
    </div>
  </div>
  } @else {
  non renseigné
  }
</ng-template>

<ng-template #headerRight>
  <button mat-flat-button color="primary" class="card-header-actions" (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>
